import ALL from './ALL';
import ANG from './ANG';
import BAM from './BAM';
import BGN from './BGN';
import BYN from './BYN';
import CHF from './CHF';
import CZK from './CZK';
import DKK from './DKK';
import EUR from './EUR';
import GBP from './GBP';
import GEL from './GEL';
import GIP from './GIP';
import HRK from './HRK';
import HUF from './HUF';
import ISK from './ISK';
import MDL from './MDL';
import MKD from './MKD';
import NOK from './NOK';
import PLN from './PLN';
import RON from './RON';
import RSD from './RSD';
import RUB from './RUB';
import SEK from './SEK';
import UAH from './UAH';

export const EUROPE_CURRENCIES = {
    [ALL.codeNumeric]: ALL,
    [ANG.codeNumeric]: ANG,
    [BAM.codeNumeric]: BAM,
    [BGN.codeNumeric]: BGN,
    [BYN.codeNumeric]: BYN,
    [CHF.codeNumeric]: CHF,
    [CZK.codeNumeric]: CZK,
    [DKK.codeNumeric]: DKK,
    [EUR.codeNumeric]: EUR,
    [GBP.codeNumeric]: GBP,
    [GEL.codeNumeric]: GEL,
    [GIP.codeNumeric]: GIP,
    [HRK.codeNumeric]: HRK,
    [HUF.codeNumeric]: HUF,
    [ISK.codeNumeric]: ISK,
    [MDL.codeNumeric]: MDL,
    [MKD.codeNumeric]: MKD,
    [NOK.codeNumeric]: NOK,
    [PLN.codeNumeric]: PLN,
    [RON.codeNumeric]: RON,
    [RSD.codeNumeric]: RSD,
    [RUB.codeNumeric]: RUB,
    [SEK.codeNumeric]: SEK,
    [UAH.codeNumeric]: UAH
};
